import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelMaterialImport_ds_get_materials_by_lookupcodesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { materialLookupcodes: string[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ProjectId?: number, PackagingLookups?: { PackagingId?: number, BasePackagingQuantity?: number, IsBasePackaging?: boolean, SubPackagingId?: number, SubPackagingQuantity?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialLookupcodes)) {
      missingRequiredInParams.push('\'materialLookupcodes\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_get_materials_by_lookupcodes/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { materialLookupcodes: string[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ProjectId?: number, PackagingLookups?: { PackagingId?: number, BasePackagingQuantity?: number, IsBasePackaging?: boolean, SubPackagingId?: number, SubPackagingQuantity?: number }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialLookupcodes)) {
      missingRequiredInParams.push('\'materialLookupcodes\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_get_materials_by_lookupcodes/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { materialLookupcodes: string[], $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ProjectId?: number, PackagingLookups?: { PackagingId?: number, BasePackagingQuantity?: number, IsBasePackaging?: boolean, SubPackagingId?: number, SubPackagingQuantity?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialLookupcodes)) {
      missingRequiredInParams.push('\'materialLookupcodes\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_get_materials_by_lookupcodes/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      materialLookupcodes: string[]    }) {
        if(isNil(inParams.materialLookupcodes)) {
          return true; 
        }
      return false;
    }
}
